import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import "./index.css";
import NoPage from "./pages/NoPage";
import Chat from "./pages/chat/Chat";
import { UseCaseContext } from "./hooks/UseCaseContext";
import { DEFAULT_USE_CASE } from "./utils/constants";
import LoginCallback from "./pages/auth/LoginCallback";
import { MetadataProvider } from "./providers/MetadataProvider";
import Unauthorised from "./pages/auth/Unauthorised";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";

export default function App() {
  const [useCase, setUseCase] = useState<string>(DEFAULT_USE_CASE);

  return (
    <UseCaseContext.Provider value={{ useCase, setUseCase }}>
      <MetadataProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PrivateRoute />}>
              <Route path="/" element={<Chat />} />
            </Route>
            <Route path="login" element={<LoginCallback />} />
            <Route path="unauthorised" element={<Unauthorised />} />
            <Route path="*" element={<NoPage />} />
          </Routes>
        </BrowserRouter>
      </MetadataProvider>
    </UseCaseContext.Provider>
  );
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
